// in src/customRoutes.js
import * as React from 'react';
import { Route } from 'react-router-dom';
import { Settings, SettingsData, SettingsDashboard, SettingsNotAvailable, SettingsUsers, SettingsTicketsUsers, SettingsAddMember,SettingsEmails,SettingsEmailsItem,SettingsSAdmin, SettingsGeneralConfiguration, SettingsClassroomRequests,SettingsAnnuaryForm, SettingsProfile, SettingsDonationsCertificates, SettingsDonationsOwn, SettingsDocs, SettingsCardValidation  } from './settings';
import { AddMember } from './components/AddMember';
import { SettingsIbans } from './components/Banks';
import { SettingsSenders, SettingsSmtp } from './components/Senders';
import { SettingsTickets } from './components/Tickets';
import { SettingsTicketsReservations } from './components/TicketsReservations';
import { SettingsTicketsGeneral } from './components/TicketsGeneral';
import { SettingsTicketsDiscounts } from './components/TicketsDiscounts';
import { SettingsTicketsGroups } from './components/TicketsGroups';
import { SettingsTicketsMaps } from './components/TicketsMaps';
import { SettingsTicketsValidators } from './components/TicketsValidators';
import { SettingsPaymentSystems } from './components/PaymentSystems';
import { SettingsPostalLabels } from './components/PostalLabels';
import { RecercatAddMember } from './components/RecercatAddMember';
import { RecercatValidateRequest } from './components/RecercatValidateRequest';
import { AddMemberValidate } from './components/AddMemberValidate';
import { RecercatResumeCenter } from './components/RecercatResumeCenter';
import { ForgotPassword,ResetPassword } from './components/Password';
import { ValidateSender } from './components/ValidateSender';
import { SignUp } from './components/SignUp';
import { default as Dashboard } from './components/Dashboard';
import { NotFound } from './components/NotFound';
import { ClassroomsRequests, ClassroomsRequestsItem } from './components/ClassroomsRequests';
import { Reports,ReportsAnnuary,ReportsResponsabilities,ReportsLeftMembers,ReportsDonationsTransferValidations, ReportsDonationsProjects, ReportsDonationsPayments, ReportsDonationsCertificates } from './components/Reports';
import PublicOccupancy from './components/PublicOccupancy';
import { PublicEventsList, PublicEvent } from './components/PublicEvents';
import { CheckMembers } from './components/CheckMembers';
import { AnnuaryForm } from './components/Annuary';
import { ModulesViewList } from './components/ModulesView';
import { DonationsUsersList } from './resources/donations_users';
import { RedisCache } from './components/RedisCache';
import { MassiveActions } from './components/MassiveActions';
import { AraTiquetsCategories, AraTiquetsConfiguration, AraTiquetsStatistics } from './components/AraTiquetsAdmin';
import { SettingsEventsSubscriptions } from './resources/events_subscriptions';
import { AraTiquetsAdminSessionsList } from './resources/ara_tiquets_admin_sessions';
import { SuperadminPayments } from './components/SuperadminPayments';
import { DonationsModel182 } from './components/DonationsModel182';

export default [
  <Route exact path="/dashboard" component={Dashboard} />,
  <Route exact path="/not-found" component={NotFound} noLayout /> ,   
  <Route exact path="/settings" component={Settings} />,
  <Route exact path="/settings-data" component={SettingsData} />,
  <Route exact path="/settings-dashboard" component={SettingsDashboard} />,
  <Route exact path="/settings-ibans" component={SettingsIbans} />,
  <Route exact path="/settings-senders" component={SettingsSenders} />,
  <Route exact path="/settings-smtp" component={SettingsSmtp} />,
  <Route exact path="/settings-payment-systems" component={SettingsPaymentSystems} />,
  <Route exact path="/settings-postal-labels" component={SettingsPostalLabels} />,
  <Route exact path="/settings-add-member" component={SettingsAddMember} />,    
  <Route exact path="/settings-card-validation" component={SettingsCardValidation} />,
  <Route exact path="/settings-classrooms-requests" component={SettingsClassroomRequests} />,
  <Route exact path="/settings-annuary-form" component={SettingsAnnuaryForm} />, 
  <Route exact path="/settings-donations-certificates" component={SettingsDonationsCertificates} />,
  <Route exact path="/settings-donations-own" component={SettingsDonationsOwn} />,
  <Route exact path="/settings-tickets" component={SettingsTickets} />,
  <Route exact path="/settings-tickets-reservations" component={SettingsTicketsReservations} />,
  <Route exact path="/settings-tickets-general" component={SettingsTicketsGeneral} />,
  <Route exact path="/settings-tickets-discounts" component={SettingsTicketsDiscounts} />,
  <Route exact path="/settings-tickets-groups" component={SettingsTicketsGroups} />,
  <Route exact path="/settings-tickets-maps" component={SettingsTicketsMaps} />,
  <Route exact path="/settings-tickets-validators" component={SettingsTicketsValidators} />,
  <Route exact path="/settings-events-subscriptions" component={SettingsEventsSubscriptions} />,
  <Route exact path="/settings-docs" component={SettingsDocs} />,
  <Route exact path="/settings-emails" component={SettingsEmails} />,
  <Route exact path="/settings-emails/:id" component={SettingsEmailsItem} />,
  <Route exact path="/settings-emails/:id/docs" component={SettingsEmailsItem} />,
  <Route exact path="/settings-users" component={SettingsUsers} />,
  <Route exact path="/settings-tickets-users" component={SettingsTicketsUsers} />,
  <Route exact path="/settings-subscription" component={SettingsNotAvailable} />,
  <Route exact path="/settings-profile" component={SettingsProfile} />,
  <Route exact path="/settings-general" component={SettingsGeneralConfiguration} />,
  <Route exact path="/settings-general/taxes" component={SettingsGeneralConfiguration} />,
  <Route exact path="/settings-general/fees" component={SettingsGeneralConfiguration} />,
  <Route exact path="/settings-general/tax-defaults" component={SettingsGeneralConfiguration} />,
  <Route exact path="/settings-general/model-182" component={SettingsGeneralConfiguration} />,
  <Route exact path="/settings-sadmin" component={SettingsSAdmin} />,
  <Route exact path="/redis" component={RedisCache} />,
  <Route exact path="/settings-massive-actions" component={MassiveActions} />,
  <Route exact path="/ara-tiquets" component={AraTiquetsAdminSessionsList} />,
  <Route exact path="/ara-tiquets/categories" component={AraTiquetsCategories} />,
  <Route exact path="/ara-tiquets/statistics" component={AraTiquetsStatistics} />,
  <Route exact path="/ara-tiquets/configuration" component={AraTiquetsConfiguration} />,
  <Route exact path="/payments" component={SuperadminPayments} />,
  <Route path="/public/add-member/:friendly_url" component={AddMember} noLayout/>,
  <Route path="/public/add-member" component={AddMember} noLayout/>,
  <Route path="/public/sol-licitud-carnet-recercat" component={RecercatAddMember} noLayout/>,
  <Route path="/public/validar-sol-licitud-carnet-recercat" component={RecercatValidateRequest} noLayout/>,
  <Route path="/public/validar-sol-licitud" component={AddMemberValidate} noLayout/>,
  <Route path="/public/resum-centre" component={RecercatResumeCenter} noLayout/>,
  <Route path="/public/classrooms-requests/:friendly_url" component={ClassroomsRequests} noLayout/>,
  <Route path="/public/classrooms-requests" component={ClassroomsRequests} noLayout/>,
  <Route path="/public/classrooms-requests-item" component={ClassroomsRequestsItem} noLayout/>,
  <Route exact path="/forgot-password" component={ForgotPassword} noLayout/>,
  <Route exact path="/reset-password" component={ResetPassword} noLayout/>,
  <Route exact path="/validate-sender" component={ValidateSender} noLayout/>,
  <Route exact path="/sign-up" component={SignUp} noLayout/>,
  <Route exact path="/reports" component={Reports} />,
  <Route exact path="/donations_users/:id" component={DonationsUsersList} />,
  <Route exact path="/reports/donations_certificates/:year" component={ReportsDonationsCertificates} />,
  <Route exact path="/reports/donations_model_182/:year" component={DonationsModel182} />,
  <Route exact path="/reports/donations_projects" component={ReportsDonationsProjects} />,
  <Route exact path="/reports/donations_transfer_validations" component={ReportsDonationsTransferValidations} />,
  <Route exact path="/reports/donations_users/:id" component={DonationsUsersList} />,  
  <Route exact path="/reports/donations_payments/:date_from/:date_to" component={ReportsDonationsPayments} />,  
  <Route exact path="/reports/annuary" component={ReportsAnnuary} />,
  <Route exact path="/reports/responsabilities" component={ReportsResponsabilities} />,
  <Route exact path="/reports/left_members" component={ReportsLeftMembers} />,
  <Route exact path="/modules-view" component={ModulesViewList} />,
  <Route exact path="/public/events/occupancy/:friendly_url" component={PublicOccupancy} noLayout/>, 
  <Route path="/public/events/list/:friendly_url" component={PublicEventsList} noLayout/>,
  <Route path="/public/events/list" component={PublicEventsList} noLayout/>,
  <Route path="/public/events/:friendly_url" component={PublicEvent} noLayout/>,  
  <Route path="/public/events" component={PublicEvent} noLayout/>,     
  <Route path="/public/annuary" component={AnnuaryForm} noLayout/>,
  <Route path="/public/check-members" component={CheckMembers} noLayout/>,  
    
];
